import Heading from 'LearningManager/components/Heading';
import styles from 'LearningManager/styles/CustomSetup.module.scss';
import CheckBoxCard from 'LearningManager/components/CheckBoxCard';
import { Icon, Button } from 'Components';
import { useStepper } from 'LearningManager/hooks/Stepper.context';

interface optionsProps {
	id: number;
	title: string;
	desc: string;
}

const options: optionsProps[] = [
	{
		id: 32,
		title: 'Entire organization',
		desc: '3000 users'
	}
];

const Organization = () => {
	const {
		draft: {
			customSetup: { selectedOrganizationIds }
		},
		toggleAssignUsersSelection,
		setAssignUsersSelection
	} = useStepper();

	const handleCheckboxChange = (id: number, checked: boolean) => {
		if (checked !== selectedOrganizationIds.includes(id)) {
			toggleAssignUsersSelection('selectedOrganizationIds', id);
		}
	};

	const handleSelectAll = () => {
		if (selectedOrganizationIds.length === options.length) {
			setAssignUsersSelection('selectedOrganizationIds', []);
		} else {
			setAssignUsersSelection(
				'selectedOrganizationIds',
				options.map((opt) => opt.id)
			);
		}
	};

	const isAllSelected = selectedOrganizationIds.length === options.length;

	return (
		<div>
			<div className={styles.header}>
				<Heading
					titleClassName={styles.title}
					title="Organization"
					astrix={true}
				/>
				{options.length > 1 && (
					<Button
						className={styles.selectAllBtn}
						onClick={handleSelectAll}
						type="link"
						size="middle"
					>
						{isAllSelected ? 'Deselect all' : 'Select all'}
					</Button>
				)}
			</div>
			<div className={styles.container}>
				{options.map((option) => (
					<CheckBoxCard
						key={option.id}
						id={option.id}
						icon={<Icon type="orgOptIcon" />}
						title={option.title}
						desc={option.desc}
						isChecked={selectedOrganizationIds.includes(option.id)}
						onChange={handleCheckboxChange}
					/>
				))}
			</div>
		</div>
	);
};

export default Organization;
